// extracted by mini-css-extract-plugin
export default {"myPageArea":"CustomerMyPage_myPageArea__mlOIe","container":"CustomerMyPage_container__hBi5C","content":"CustomerMyPage_content__MRgq1"};